import { render, staticRenderFns } from "./CUIcon.vue?vue&type=template&id=6397765b&scoped=true"
import script from "./CUIcon.vue?vue&type=script&lang=ts"
export * from "./CUIcon.vue?vue&type=script&lang=ts"
import style0 from "./CUIcon.vue?vue&type=style&index=0&id=6397765b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397765b",
  null
  
)

export default component.exports